import { render } from "./MovieExtras.vue?vue&type=template&id=5cf04570&scoped=true"
import script from "./MovieExtras.vue?vue&type=script&lang=js"
export * from "./MovieExtras.vue?vue&type=script&lang=js"

import "./MovieExtras.vue?vue&type=style&index=0&id=5cf04570&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf04570"]])

export default __exports__